import { render, staticRenderFns } from "./SwappTasksTaskForm.vue?vue&type=template&id=7283e5e9&scoped=true"
import script from "./SwappTasksTaskForm.vue?vue&type=script&lang=js"
export * from "./SwappTasksTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7283e5e9",
  null
  
)

export default component.exports